import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg data-[rich-colors=true]:data-[type=error]:!bg-red-500 data-[rich-colors=true]:data-[type=error]:!text-white data-[rich-colors=true]:data-[type=success]:!bg-green-500 data-[rich-colors=true]:data-[type=success]:!text-white",
          description: "group-[.toast]:text-muted-foreground data-[rich-colors=true]:group-[.toast]:text-white/80",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
